import { render, staticRenderFns } from "./RestaurantDefault.vue?vue&type=template&id=5bc85332&"
import script from "./RestaurantDefault.vue?vue&type=script&lang=js&"
export * from "./RestaurantDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports